import { useState, useEffect } from 'react'
import axios from 'axios'

type OnboardingVersion = 'v2' | 'v3'

let cachedVersion: OnboardingVersion | null = null

export const useOnboardingConfig = () => {
    const [defaultVersion, setDefaultVersion] = useState<OnboardingVersion>(cachedVersion || 'v2')
    const [loading, setLoading] = useState(!cachedVersion)

    useEffect(() => {
        if (cachedVersion) return

        axios
            .get<{ success: boolean; data: { defaultVersion: OnboardingVersion } }>('/public/config/onboarding')
            .then((res) => {
                const version = res.data?.data?.defaultVersion || 'v2'
                cachedVersion = version
                setDefaultVersion(version)
            })
            .catch((error) => {
                console.warn('Failed to fetch onboarding config, defaulting to v2:', error?.message || error)
                // Don't cache on error — allow retry on next mount so transient failures don't permanently lock users to v2
            })
            .finally(() => setLoading(false))
    }, [])

    return { defaultVersion, isSpotEnabled: defaultVersion === 'v3', loading }
}
